import { useState, useEffect } from 'react';
import Popup from '../components/Popup/EbookPopup'; // Adjust the import path as necessary
import { HelmetProvider } from 'react-helmet-async';
import { Helmet } from 'react-helmet';

// Define the Ebook type
interface Ebook {
    id: number;
    title: string;
    url: string;
    thumbnail: string;
}

const Ebooks = () => {
  const [selectedEbook, setSelectedEbook] = useState<Ebook | null>(null);
  const [showPopup, setShowPopup] = useState(false);

  const ebooks: Ebook[] = [
    // { id: 1, title: 'Discover Bali', url: '/Ebooks/bali.pdf', thumbnail: '/Ebooks/bali.jpg' },
    { id: 1, title: 'Guide to Maldives', url: '/Ebooks/maldives.pdf', thumbnail: '/Ebooks/maldives.jpg' },
    // { id: 3, title: 'Explore Cancun', url: '/Ebooks/cancun.pdf', thumbnail: '/Ebooks/cancun.jpg' },
    { id: 2, title: 'Magic of Disneyland Paris', url: '/Ebooks/disney.pdf', thumbnail: '/Ebooks/disney.jpg' },
    // { id: 5, title: 'Secrets of Dubai', url: '/Ebooks/dubai.pdf', thumbnail: '/Ebooks/dubai.jpg' },
    { id: 3, title: 'Adventures in Japan', url: '/Ebooks/japan.pdf', thumbnail: '/Ebooks/japan.jpg' },
];

useEffect(() => {
  window.scrollTo(0, 0);
}, []);

  const handleDownloadClick = (ebook: Ebook) => {
    setSelectedEbook(ebook);
    setShowPopup(true);
  };

  return (
    <>
    <HelmetProvider>
        <Helmet>
          <title>Travel eBooks | Free Download | Halo Holidays</title>
          <meta name="description" content="Download our free travel eBooks and get inspired for your next adventure. Discover insider tips, destination guides, and more." />
        </Helmet>
    </HelmetProvider>

    <div className="p-4">
      <h1 className="text-4xl font-bold text-center mb-4 mt-[-100px] md:mt-0">Our E-Books</h1>
      <div className="grid grid-cols-1 md:grid-cols-5 gap-4 mb-5">
        {ebooks.map((book) => (
          <div key={book.id} className="flex flex-col items-center">
            <img src={book.thumbnail} alt={book.title} className="w-full h-auto object-cover rounded" />
            <h2 className="mt-2 text-lg font-semibold text-center">{book.title}</h2>
            <button
              onClick={() => handleDownloadClick(book)}
              className="mt-2 text-halo-pink rounded bg-white p-2 shadow-md w-full text-center"
            >
              Download
            </button>
          </div>
        ))}
      </div>
      {showPopup && selectedEbook && (
        <Popup
          onClose={() => setShowPopup(false)}
          ebook={selectedEbook}
        />
      )}
    </div>
    </>
  );
};

export default Ebooks;
